import React from 'react'
import Box from '@mui/material/Box';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import RateReviewRoundedIcon from '@mui/icons-material/RateReviewRounded';
import ManageHistoryRoundedIcon from '@mui/icons-material/ManageHistoryRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';

// ขั้นตอนของเอกสาร: Draft → Review → Approval → Finalization
const steps = [
  { label: 'Draft', desc: 'Initial document creation', Icon: EditNoteRoundedIcon, color: '#78909c' },
  { label: 'Review', desc: 'Document under review', Icon: RateReviewRoundedIcon, color: '#1e88e5' },
  { label: 'Approval', desc: 'Awaiting final approval', Icon: ManageHistoryRoundedIcon, color: '#ef6c00' },
  { label: 'Finalization', desc: 'Document finalized', Icon: VerifiedRoundedIcon, color: '#43a047' },
];

const CardStepper = (props) => {
  const counts = [props.countInDraft, props.countInpreveiw, props.countapproved, props.countSuccessfully];

  return (
    <Box sx={{ p: 2.5, borderRadius: 3, bgcolor: '#fff', border: '1px solid #e3e6ea' }}>
      <Box sx={{ mb: 2.5 }}>
        <Box sx={{ fontWeight: 700, fontSize: 16.5, color: '#263238' }}>Document Lifecycle</Box>
        <Box sx={{ fontSize: 12.5, color: '#78909c' }}>จำนวนเอกสารในแต่ละขั้นตอนของ workflow</Box>
      </Box>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, 1fr)' }, gap: 2 }}>
        {steps.map((step, i) => (
          <Box key={step.label} sx={{ position: 'relative' }}>
            {/* เส้นเชื่อมไปขั้นถัดไป */}
            {i < steps.length - 1 && (
              <Box sx={{
                display: { xs: 'none', md: 'block' },
                position: 'absolute', top: 27, left: 'calc(50% + 36px)', right: 'calc(-50% + 36px)',
                height: 3, borderRadius: 999,
                background: `linear-gradient(90deg, ${step.color} 0%, ${steps[i + 1].color} 100%)`,
                opacity: 0.45,
              }} />
            )}

            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
              <Box sx={{
                position: 'relative', zIndex: 1,
                width: 56, height: 56, borderRadius: '50%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: `linear-gradient(135deg, ${step.color} 0%, ${step.color}b3 100%)`,
                boxShadow: `0 0 0 6px #fff, 0 6px 16px ${step.color}55`,
                color: '#fff',
              }}>
                <step.Icon sx={{ fontSize: 28 }} />
              </Box>

              <Box sx={{
                mt: 2, width: '100%', p: 1.75, borderRadius: 2.5,
                bgcolor: `${step.color}0d`, border: `1px solid ${step.color}26`,
              }}>
                <Box sx={{ fontSize: 11, fontWeight: 700, color: step.color, letterSpacing: 0.6 }}>STEP {i + 1}</Box>
                <Box sx={{ fontSize: 15.5, fontWeight: 700, color: '#263238', mt: 0.25 }}>{step.label}</Box>
                <Box sx={{ fontSize: 12, color: '#78909c' }}>{step.desc}</Box>
                <Box sx={{
                  display: 'inline-flex', alignItems: 'baseline', gap: 0.5,
                  mt: 1.25, px: 1.5, py: 0.5, borderRadius: 999,
                  bgcolor: '#fff', border: `1px solid ${step.color}33`,
                }}>
                  <Box component="span" sx={{ fontSize: 18, fontWeight: 800, color: step.color }}>{counts[i]}</Box>
                  <Box component="span" sx={{ fontSize: 12, color: '#78909c' }}>Documents</Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default CardStepper
